// extracted by mini-css-extract-plugin
export default {"button":"mp-z","reviewSort":"np-z"};